import React from 'react';
import NextLink from 'next/link';
import { connect } from 'react-redux';
import { GEN_ROLLOUT_COOKIE_NAME } from 'constants/gen';

// TEMP wrapper to disable client side routing on prod during rollout
// This code can be removed after we deploy post pages.

const shouldClientRoute = props => {
  // If the partial rollout cookie is set disable client side routing
  if (
    props.flips.includes(GEN_ROLLOUT_COOKIE_NAME) &&
    props.children.type === 'a'
  ) {
    // NOTE, we're checking if the child is an <a>. If this was a long term solution
    // we'd want to be more careful with this, however at this time all children
    // will be standard links.
    return false;
  }
  return true;
};

/* eslint-disable react/prop-types */
function Link(props) {
  const { flips, dispatch, ...rest } = props;
  if (shouldClientRoute(props)) {
    // Return link component
    return <NextLink {...rest} prefetch={false} />;
  }
  // Return a standard link
  return React.cloneElement(
    props.children,
    {
      href: props.as || props.href
    },
    props.children.props.children
  );
}

export default connect(({ app }) => ({
  flips: app.flips
}))(Link);
